import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Modal, ModalHeader, ModalBody } from '@spotahome/ui-library';

import CopyToClipboardButton from './CopyToClipboardButton';
import ShareOnSocial from './ShareOnSocial';

import './ShareModal.scss';

const ShareModal = ({ isOpen, onRequestClose, listingId }) => (
  <Modal
    className="share-button-modal"
    isOpen={isOpen}
    size="medium"
    contentLabel="modal"
    ariaHideApp={false}
    onRequestClose={onRequestClose}
  >
    <ModalHeader
      className="share-button-modal__header"
      label={trans('booknowcard.share.button.modal-header')}
      onRequestClose={onRequestClose}
      dataCy="booknowcard_share_closeButton"
    />
    <ModalBody>
      <div className="share-button-modal__button-group">
        <ShareOnSocial listingId={listingId} social="whatsapp" />
        <ShareOnSocial listingId={listingId} social="facebook" />
        <ShareOnSocial listingId={listingId} social="email" />
        <CopyToClipboardButton listingId={listingId} />
      </div>
    </ModalBody>
  </Modal>
);

ShareModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  listingId: PropTypes.string.isRequired
};

export default ShareModal;
